import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { toast } from "sonner";

import { MeasuringUnitDto } from "@/lib/schema/unit";
import { MeasuringUnit } from "@/types/unit";
import { api } from "@/lib/auth";
import { apiRoutes } from "@/config/api-route";

export const useGetMeasuringUnit = () => {
  const queryClient = useQueryClient();

  const { data: units = [], isLoading: isFetchingUnits } = useQuery({
    queryKey: ["measuringUnits"],
    queryFn: async () =>
      await api.get<MeasuringUnit[]>(apiRoutes.measuringUnits.getAll),
    staleTime: Infinity,
  });

  const { mutateAsync: createMeasuringUnit } = useMutation({
    mutationFn: async (unit: MeasuringUnitDto) => {
      return await api.post(apiRoutes.measuringUnits.create, unit);
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["measuringUnits"] });
      toast.success("Measuring Unit created successfully");
    },
    onError: (error) => {
      console.log(JSON.stringify(error, null, 2));
      toast.error(error?.message || "Failed to create measuring unit");
    },
  });

  return { units, isFetchingUnits, createMeasuringUnit };
};
